export const provident_funds = [
  {
    key:"1",
    Employee_Name: "Anthony Lewis",
    Image: "user-32.jpg",
    Roll: "Finance",
    Provident_Fund_Type: "Employee Provident Fund",
    Employee_Share: "2%",
    Organization_Share: "2%",
    Status: "Approved",
  },
  {
    key:"2",
    Employee_Name: "Brian Villalobos",
    Image: "user-09.jpg",
    Roll: "Developer",
    Provident_Fund_Type: "Employee Provident Fund",
    Employee_Share: "2%",
    Organization_Share: "2%",
    Status: "Pending",
  },
  {
    key:"3",
    Employee_Name: "Harvey Smith",
    Image: "user-01.jpg",
    Roll: "Developer",
    Provident_Fund_Type: "Voluntary Provident Fund",
    Employee_Share: "5%",
    Organization_Share: "2%",
    Status: "Approved",
  },
  {
    key:"4",
    Employee_Name: "Stephan Peralt",
    Image: "user-33.jpg",
    Roll: "Executive Officer",
    Provident_Fund_Type: "Voluntary Provident Fund",
    Employee_Share: "3%",
    Organization_Share: "2%",
    Status: "Pending",
  },
  {
    key:"5",
    Employee_Name: "Doglas Martini",
    Image: "user-34.jpg",
    Roll: "Manager",
    Provident_Fund_Type: "Employee Provident Fund",
    Employee_Share: "2%",
    Organization_Share: "2%",
    Status: "Approved",
  },
  {
    key:"6",
    Employee_Name: "Linda Ray",
    Image: "user-02.jpg",
    Roll: "Finance",
    Provident_Fund_Type: "Employee Provident Fund",
    Employee_Share: "2%",
    Organization_Share: "2%",
    Status: "Pending",
  },
  {
    key:"7",
    Employee_Name: "Elliot Murray",
    Image: "user-35.jpg",
    Roll: "Developer",
    Provident_Fund_Type: "Voluntary Provident Fund",
    Employee_Share: "6%",
    Organization_Share: "2%",
    Status: "Approved",
  },
  {
    key:"8",
    Employee_Name: "Rebecca Smtih",
    Image: "user-36.jpg",
    Roll: "Executive",
    Provident_Fund_Type: "Voluntary Provident Fund",
    Employee_Share: "4%",
    Organization_Share: "2%",
    Status: "Pending",
  },
  {
    key:"9",
    Employee_Name: "Connie Waters",
    Image: "user-37.jpg",
    Roll: "Developer",
    Provident_Fund_Type: "Employee Provident Fund",
    Employee_Share: "2%",
    Organization_Share: "2%",
    Status: "Approved",
  },
  {
    key:"10",
    Employee_Name: "Lori Broaddus",
    Image: "user-38.jpg",
    Roll: "Finance",
    Provident_Fund_Type: "Voluntary Provident Fund",
    Employee_Share: "7%",
    Organization_Share: "2%",
    Status: "Pending",
  },
];
